import React from 'react';
import { Box, Heading, Text, TextButton } from '@wix/design-system';
import { DomainSearchSuiteModule } from '../../module/domainSearchSuite.module';
import styles from './NoPermissionsBlock.module.scss';
export const NoPermissionsBlock = () => {
  const _DomainSearchSuiteMod = DomainSearchSuiteModule.internals.useTranslations(),
    t = _DomainSearchSuiteMod.t,
    Trans = _DomainSearchSuiteMod.Trans;
  const learnMoreUrl = t('domain_search_suite.error.no_permissions_block.full_page.learn_more.link');
  return /*#__PURE__*/React.createElement(Box, {
    height: "100%",
    width: "100%",
    verticalAlign: "middle",
    align: "center",
    direction: "vertical",
    alignContent: "center",
    textAlign: "center"
  }, /*#__PURE__*/React.createElement(Box, {
    gap: "SP2",
    direction: "vertical",
    padding: "SP3 SP6"
  }, /*#__PURE__*/React.createElement(Heading, {
    size: "large",
    className: styles.heading
  }, t('domain_search_suite.error.no_permissions_block.full_page.title')), /*#__PURE__*/React.createElement(Text, {
    size: "small"
  }, t('domain_search_suite.error.no_permissions_block.full_page.sub_title'))), /*#__PURE__*/React.createElement(Text, {
    size: "small"
  }, /*#__PURE__*/React.createElement(Trans, {
    i18nKey: "domain_search_suite.error.no_permissions_block.full_page.learn_more",
    components: [/*#__PURE__*/React.createElement(TextButton, {
      size: "small",
      as: "a",
      href: learnMoreUrl,
      target: "_blank",
      rel: "noopener noreferrer"
    })]
  })));
};
//# sourceMappingURL=NoPermissionsBlock.js.map